import { type SVGProps } from "react";
const IconNavDilemma = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="m10.088.148-.005-.005a.47.47 0 0 0-.39-.138H2.38A2.381 2.381 0 0 0 0 2.385V17.62A2.381 2.381 0 0 0 2.38 20h10.603a2.381 2.381 0 0 0 2.38-2.38V5.613a.49.49 0 0 0-.138-.338L10.088.148Zm.129 1.476 3.532 3.523h-2.104a1.433 1.433 0 0 1-1.428-1.429V1.624Zm2.77 17.42H2.38a1.433 1.433 0 0 1-1.428-1.43V2.382A1.433 1.433 0 0 1 2.38.952h6.884v2.766a2.381 2.381 0 0 0 2.38 2.38h2.767v11.517a1.426 1.426 0 0 1-1.424 1.428Z"
    />
    <path
      fill="currentColor"
      d="M3.052 9.188h5.146a.476.476 0 0 0 0-.952H3.052a.476.476 0 1 0 0 .952Z"
    />
    <path
      fill="currentColor"
      d="M12.316 11.835H3.052a.476.476 0 1 0 0 .952h9.264a.476.476 0 0 0 0-.952ZM12.316 15.44H3.052a.476.476 0 1 0 0 .951h9.264a.476.476 0 0 0 0-.952Z"
    />
  </svg>
);
export default IconNavDilemma;
